
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { PostService } from '../../services/post-service';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
//import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
//import Loading from "../../components/layouts/loading";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 820,
  bgcolor: 'background.paper',
  borderRadius: '6px',
  border: '1px solid #fff',
  boxShadow: 24,
  p: 2,
  textAlign: 'center'
};

export default function SingleArticle({ _kind = 'post', _all_origin_domain, onUpdate, index, widget, info = { title: "" } }) {

  const pageSize = 50;
  const searchTitleRef = useRef();
  const defaultPost = { databaseId: 0, title: 'Select post...' };
  const kind = _kind;
  const allOriginDomain = _all_origin_domain;
  const [originDomain, setOriginDomain] = useState(allOriginDomain[1]);
  const [searchTitleValue, setSearchTitleValue] = useState('');
  //const [databaseId, setDatabaseId] = useState('');
  const [postList, setPostList] = useState([]);
  const [post, setPost] = useState(defaultPost);
  const [reversed, setReversed] = useState(false);
  const [pcount, setPcount] = useState(0);
  const isInModification = widget[0]?.data && Object.keys(widget[0]?.data)?.length > 0;

  //Mui Modal
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => setOpenModal(true);
  //const handleClose = () => setOpenModal(false);
  const [isLoading, setIsLoading] = useState(false);

  //Menu Post title
  const [anchorElPost, setAnchorElPost] = useState(null);
  const mopenPost = Boolean(anchorElPost);
  const handlePostClick = (event) => {
    setAnchorElPost(event.currentTarget);
  };
  function handlePostClose(e) {
    setAnchorElPost(null);
  }

  //Menu Origin Domain
  const [anchorElDomain, setAnchorElDomain] = useState(null);
  const mopenDomain = Boolean(anchorElDomain);
  const handleDomainClick = (event) => {
    setAnchorElDomain(event.currentTarget);
  };
  function handleDomainClose() {
    searchTitleRef.current.value = '';
    setAnchorElDomain(null);
  }

  useEffect(() => {
    handleOpen();
    if (isInModification) {
      setOriginDomain(widget[0]?.data?.origin_domain);
      setPost({ databaseId: widget[0]?.data?.databaseId, kind: widget[0]?.data?.kind, origin_domain: widget[0]?.data?.origin_domain, title: widget[0]?.data?.title });
      setReversed(widget[0]?.data?.reversed ? widget[0]?.data?.reversed : false);
    }
    //console.log('SingleArticle in modifica: ', isInModification)
  }, [isInModification, widget, setOriginDomain]);

  //Gestione chiusura del modal
  function handleClose(event, reason) {
    //console.log(event, reason);
    switch (reason) {
      case 'backdropClick':
        return;
      case 'escapeKeyDown':
        return;
      default:
        setOpenModal(false);
    }
  }

  const fetchData = useCallback(async (_kind, _originDomain, _title) => {
    //console.log('Data:', _kind, _originDomain, _title);
    if (_originDomain === 'All_domain') _originDomain = "";

    setIsLoading(true);
    const postList = await PostService.getList(
      {
        kind: _kind,
        origin_domain: _originDomain,
        title__icontains: _title,
        page_size: pageSize
      }
    );

    if (postList.count === 0) {
      console.error(`No posts o backend for params: ${_kind} and ${_originDomain}`);
      setPostList([{ title: 'Nessun risultato!' }]);
    } else {
      setPostList(postList.results);
    }
    //console.log('postList: ', postList.results);
    setPcount(postList.count)
    setIsLoading(false);
  }, [pageSize])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchData(kind, originDomain, searchTitleValue);
    }, 250)
    return () => clearTimeout(delayDebounceFn)
  }, [kind, originDomain, searchTitleValue, fetchData]);

  function handleChange(event) {
    setSearchTitleValue(searchTitleRef.current.value);
    setPost(defaultPost);
  }

  function keyPress(event) {
    if (event.key === 'Enter') {
      setSearchTitleValue(searchTitleRef.current.value);
      setPost(defaultPost)
    }
  }

  return (
    <>
      <Modal
        aria-labelledby="livetag-modal-title"
        aria-describedby="livetag-modal-description"
        open={openModal}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      //disableEscapeKeyDown={true} 
      >
        <Fade in={openModal}>
          <Box sx={style}>
            <Typography id="livetag-modal-title" variant="h6" component="h2"
              style={{ marginBottom: "20px" }}>
              {isInModification ? info.title : 'New ' + info.title}
            </Typography>
            <div className="row" style={{ margin: "auto", textAlign: "left" }}>
              <div className="col-12 col-md-12 col-lg-3 col-xl-3">
                <div className="fw-bold p-1">Origin Domain</div>
                <button type="button" className="btn btn-light" data-bs-display="static" aria-expanded="false"
                  onClick={handleDomainClick} style={{ minWidth: "160px", backgroundColor: "#0a58ca", color: "white" }} >
                  {originDomain}
                </button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorElDomain}
                  open={mopenDomain}
                  onClose={handleDomainClose}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                >
                  {allOriginDomain.map((e, i) => {
                    return <MenuItem key={i} onClick={() => {
                      handleDomainClose(); setOriginDomain(e);
                      setPost(defaultPost); setSearchTitleValue('');
                    }}>{e}</MenuItem>
                  })}
                </Menu>
                {widget[0].widget !== "SingleHugeArticle" ?
                  <FormGroup aria-label="reversed">
                    <FormControlLabel
                      sx={{
                        marginTop: "20px",
                        flexDirection: 'row',
                        '.MuiFormControlLabel-label': {
                          fontWeight: "600",
                        },
                      }}
                      value="start"
                      control={
                        <Checkbox
                          checked={reversed ? reversed : false}
                          onChange={(event) => setReversed(event.target.checked)}
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      }
                      label="Reversed"
                      labelPlacement="start" />
                  </FormGroup> : ""}
              </div>
              <div className="col-12 col-md-12 col-lg-9 col-xl-9">
                <div className="fw-bold p-1" style={{ textTransform: 'capitalize' }}>{kind}</div>
                <div className="input-group">
                  <input type="text" className="form-control" placeholder="Search Title"
                    style={{ padding: "6px" }}
                    onKeyDown={(e) => keyPress(e)}
                    ref={searchTitleRef}
                    defaultValue={searchTitleValue}
                    onChange={handleChange}
                    aria-label="Search post title" aria-describedby="button-search" />
                  <button className="btn btn-primary" type="button" id="button-search-slug"
                    onClick={() => { setSearchTitleValue(searchTitleRef.current.value); setPost(defaultPost); }}>
                    <FontAwesomeIcon icon={['fas', 'search']} size={'1x'} color={'white'} />
                  </button>
                </div>
                {!isLoading ?
                  <>
                    <button type="button" className="btn btn-light" data-bs-display="static" aria-expanded="false"
                      onClick={handlePostClick} style={{
                        width: "100%", minWidth: "120px", marginTop: "4px",
                        minHeight: "62px", backgroundColor: "#0a58ca", color: "white"
                      }} >
                      {post?.title}
                    </button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorElPost}
                      open={mopenPost}
                      onClose={handlePostClose}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}
                    >
                      {postList.map((e, i) => {
                        return <MenuItem key={i} onClick={() => { handlePostClose(); setPost(e); }}>{e.title}</MenuItem>
                      })}
                    </Menu>
                  </>
                  : <button type="button" className="btn btn-light" data-bs-display="static" aria-expanded="false"
                    style={{
                      width: "100%", minWidth: "120px", marginTop: "4px",
                      minHeight: "62px", backgroundColor: "#0a58ca", color: "white"
                    }} >
                    <Box sx={{ width: '100%' }}>
                      Ricerca...
                      <LinearProgress />
                    </Box>
                  </button>
                }
              </div>

            </div>
            <div className='justify-content-center p-5'>
              {pcount + ' trovati (seleziona tra i più recenti o cerca per titolo)'}
            </div>
            <div className="row">
              <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                <button type="button" className="btn btn-secondary"
                  style={{ minWidth: '6rem', marginLeft: '10px', float: "left" }}
                  onClick={() => { ((widget[0]?.data && isInModification) ? onUpdate(null, -1) : onUpdate(null, index)); handleClose(); }}>
                  Chiudi
                </button>
              </div>
              <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                {(post.databaseId && post.databaseId !== 0) ?
                  <button type="button" className="btn btn-success"
                    style={{ minWidth: '6rem', marginRight: '10px', float: "right" }}
                    onClick={() => {
                      onUpdate(
                        {
                          databaseId: post.databaseId,
                          kind: post.kind,
                          origin_domain: post.origin_domain,
                          title: post.title,
                          reversed: reversed
                        }
                        , index); handleClose();
                    }}>
                    Conferma
                  </button>
                  : ''}
              </div>
            </div>
          </Box>
        </Fade>
      </Modal >
    </>
  );
}